export class MigrationProcessingRoute {
  id?: string;
  migrationProcessingId?: string;
  name?: string;
  fromActivity?: string;
  toActivity?: string;
  logicalOperator?: string;
  displayOrder?: number;
  isActive?: boolean;
  createdOn?: Date;
  createdBy?: string;
  modifiedOn?: Date;
  modifiedBy?: string;
  conditions?: MigrationProcessingRouteCondition[];

  constructor(init?: Partial<MigrationProcessingRoute>) {
    Object.assign(this, init);
  }
}

export class MigrationProcessingRouteCondition {
  id?: string;
  migrationProcessingRouteId?: string;
  field?: string;
  operator?: string;
  value?: string;
  displayOrder?: number;
  createdOn?: Date;
  createdBy?: string;
  modifiedOn?: Date;
  modifiedBy?: string;

  constructor(init?: Partial<MigrationProcessingRouteCondition>) {
    Object.assign(this, init);
  }
}
